/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../completed.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/completed/ebit-banner/completed.ebit-banner.component';
import * as i3 from 'ng2-device-detector';
const styles_CompletedEbitBannerComponent:any[] = [i0.styles];
export const RenderType_CompletedEbitBannerComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_CompletedEbitBannerComponent,data:{}});
export function View_CompletedEbitBannerComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'a',[['id','bannerEbit']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      0,'param',[['id','ebitParam']],[[8,'value',0]],(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:i2.CompletedEbitBannerComponent = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',_co.paramValue,'');
    _ck(_v,2,0,currVal_0);
  });
}
export function View_CompletedEbitBannerComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'completed-ebit-banner',
      ([] as any[]),(null as any),(null as any),(null as any),View_CompletedEbitBannerComponent_0,
      RenderType_CompletedEbitBannerComponent)),i1.ɵdid(1,4308992,(null as any),0,
      i2.CompletedEbitBannerComponent,[i3.Ng2DeviceService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const CompletedEbitBannerComponentNgFactory:i1.ComponentFactory<i2.CompletedEbitBannerComponent> = i1.ɵccf('completed-ebit-banner',
    i2.CompletedEbitBannerComponent,View_CompletedEbitBannerComponent_Host_0,{ebitStoreId:'ebitStoreId',
        offerable:'offerable'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjMzg5NDQ2MTU1OS9zcmMvc3JjL2FwcC9jb21wbGV0ZWQvZWJpdC1iYW5uZXIvY29tcGxldGVkLmViaXQtYmFubmVyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9jb2RlYnVpbGQvb3V0cHV0L3NyYzM4OTQ0NjE1NTkvc3JjL3NyYy9hcHAvY29tcGxldGVkL2ViaXQtYmFubmVyL2NvbXBsZXRlZC5lYml0LWJhbm5lci5jb21wb25lbnQudHMiLCJuZzovLy9jb2RlYnVpbGQvb3V0cHV0L3NyYzM4OTQ0NjE1NTkvc3JjL3NyYy9hcHAvY29tcGxldGVkL2ViaXQtYmFubmVyL2NvbXBsZXRlZC5lYml0LWJhbm5lci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMzg5NDQ2MTU1OS9zcmMvc3JjL2FwcC9jb21wbGV0ZWQvZWJpdC1iYW5uZXIvY29tcGxldGVkLmViaXQtYmFubmVyLmNvbXBvbmVudC50cy5Db21wbGV0ZWRFYml0QmFubmVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGEgaWQ9XCJiYW5uZXJFYml0XCI+PC9hPlxuPHBhcmFtIGlkPVwiZWJpdFBhcmFtXCIgdmFsdWU9XCJ7e3BhcmFtVmFsdWV9fVwiIC8+IiwiPGNvbXBsZXRlZC1lYml0LWJhbm5lcj48L2NvbXBsZXRlZC1lYml0LWJhbm5lcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQXVCO2FBQUEsMkJBQ3ZCO01BQUE7TUFBQTs7SUFBc0I7SUFBdEIsV0FBc0IsU0FBdEI7Ozs7b0JDREE7TUFBQTs2Q0FBQSxVQUFBO3NDQUFBOztRQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/$$_gendir/app/completed/ebit-banner/completed.ebit-banner.component.ngfactory.ts